import{b as G}from"./utils-BuG-uH50.js";const j=(a,{isSlide:e=!1,index:r=99}={})=>{var o,h,f,g,s,k,w,v;const{key:l,title:t,link:y,imageInfo:d,sellingPrice:n,listPrice:p,custom:i,ticket:x}=a,C=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",z=((g=(f=(h=(o=d==null?void 0:d.images)==null?void 0:o[0])==null?void 0:h.sources)==null?void 0:f[0])==null?void 0:g.url)||(d==null?void 0:d.thumbnail)||"",b=(n==null?void 0:n.min)||0,$=(p==null?void 0:p.min)>(n==null?void 0:n.min)?p.min:0,c=(k=(s=i==null?void 0:i.product_hover_image)==null?void 0:s[0])==null?void 0:k.label,_=(v=(w=i==null?void 0:i.colour_count)==null?void 0:w[0])==null?void 0:v.label,V=r<=2?"eager":"lazy",F=r<=2?"high":"auto";return`
    <${e?"li":"div"}
      class="product-card ${e?"splide__slide":""}"
      data-voyado-product
      data-product-key="${l}"
      data-product-ticket="${x}"
    >
      ${O(i,b,$)}
      ${P(a)}
      <a
        href="${C}${y}"
        class="product-card__image-container ${c?"has-hover":""}"
        aria-label="${t}"
      >
        <img
          src="${z}"
          alt="Image of ${t}"
          class="product-card__image-container--primary"
          width="600"
          height="800"
          loading="${V}"
          fetchpriority="${F}"
        />
        ${c?`
          <img
            src="${c}"
            alt="Secondary image of ${t}"
            class="product-card__image-container--secondary"
            width="600"
            height="800"
            loading="lazy"
          />
        `:""}
      </a>
      <div class="product-card__content">
        <p class="product-card__title f1-lc">${t}</p>
        ${M(b,$)}
      </div>
       <p
        data-product-id="${l}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${_&&_>1?`
        <p class="product-card__colour-count f2-lc">
          ${_} Colours
        </p>
      `:""}
    </${e?"li":"div"}>
  `},M=(a,e)=>{let r="",l="product-card__price--current";return e&&(r=`
      <span class="product-card__price--original f1-lc">
        ${G(e)}
      </span>
    `,l="product-card__price--discounted"),`
    <div class="product-card__price">
      ${r}
      <span class="${l} f1-lc">
        ${G(a)}
      </span>
    </div>`},O=(a,e,r)=>{var t,y,d,n,p,i,x,C,z,b,$,c,_,V,F,o,h,f,g,s,k,w,v,B,H,L,T,A;if(e&&r&&e<r)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-e/r)*100)}% OFF
      </p>
    `;let l="";return(y=(t=a==null?void 0:a.stock)==null?void 0:t[0])!=null&&y.label?l=(n=(d=a==null?void 0:a.stock)==null?void 0:d[0])==null?void 0:n.label:(i=(p=a==null?void 0:a.petite)==null?void 0:p[0])!=null&&i.label?l=(C=(x=a==null?void 0:a.petite)==null?void 0:x[0])==null?void 0:C.label:(b=(z=a==null?void 0:a.collection)==null?void 0:z[0])!=null&&b.label?l=(c=($=a==null?void 0:a.collection)==null?void 0:$[0])==null?void 0:c.label:(V=(_=a==null?void 0:a.new)==null?void 0:_[0])!=null&&V.label?l=(o=(F=a==null?void 0:a.new)==null?void 0:F[0])==null?void 0:o.label:(f=(h=a==null?void 0:a.back_in_stock)==null?void 0:h[0])!=null&&f.label?l=(s=(g=a==null?void 0:a.back_in_stock)==null?void 0:g[0])==null?void 0:s.label:(w=(k=a==null?void 0:a.available_to_rent)==null?void 0:k[0])!=null&&w.label?l=(B=(v=a==null?void 0:a.available_to_rent)==null?void 0:v[0])==null?void 0:B.label:(L=(H=a==null?void 0:a.nc_exclusive)==null?void 0:H[0])!=null&&L.label&&(l=(A=(T=a==null?void 0:a.nc_exclusive)==null?void 0:T[0])==null?void 0:A.label),l?`
      <p class="product-card__label product-label product-label--default">
        ${l}
      </p>
    `:""},P=a=>{var r;const e=((r=a.link)==null?void 0:r.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${a.key}"
      data-product-handle="${e}"
      role="button"
      tabindex="0"
      aria-label="Add to wishlist"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{j as b};
